import React from 'react';
import { Box } from '@hz-design-system/web-ui';

import FEED_ITEMS_PER_PAGE from '../../../Homepage/constants/feedItemsPerPage';
import FeedItemSkeleton from '../../../Homepage/components/Feeds/FeedItemSkeleton';
import LSClasses from './AutosFeedsListSkeleton.module.scss';

type TFeedItemListSkeleton = {
  itemsCount?: number;
};

const FeedItemListSkeleton = ({ itemsCount = FEED_ITEMS_PER_PAGE }: TFeedItemListSkeleton) => (
  <Box as="div" name="contentCards" className={LSClasses.contentCards}>
    {Array(itemsCount)
      .fill(true)
      .map((_, index) => (
        <FeedItemSkeleton key={index} />
      ))}
  </Box>
);

export default FeedItemListSkeleton;
